import React from "react";
import { MapPin, X } from "lucide-react";
import { ROOM_TYPES } from "@/lib/rooms";

export default function RoomPicker({ selected, onSelect, onClose }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-xl border border-amber-500/40 bg-slate-900/90 backdrop-blur-md" data-testid="room-picker">
      <div className="flex items-center gap-1.5 text-amber-400 shrink-0">
        <MapPin className="h-4 w-4" />
        <span className="font-mono text-[10px] uppercase tracking-widest">Place room</span>
      </div>
      <div className="flex flex-wrap gap-1.5 flex-1">
        {ROOM_TYPES.map((r) => (
          <button
            key={r.id}
            type="button"
            data-testid={`room-type-${r.id}`}
            onClick={() => onSelect(r.id)}
            className={`px-2.5 h-7 rounded-full text-xs font-medium transition-colors border ${
              selected === r.id
                ? "bg-amber-500 text-slate-950 border-amber-500"
                : "bg-slate-950 text-slate-300 border-slate-800 hover:border-slate-600"
            }`}
          >
            {r.label}
          </button>
        ))}
      </div>
      <div className="font-mono text-[10px] text-slate-500 shrink-0 hidden xl:block">Click on plan to place</div>
      <button type="button" data-testid="room-picker-close" onClick={onClose} className="text-slate-400 hover:text-slate-100 shrink-0">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
